import api from "@/Library/api.js";
import method from "@/Library/method.js";
let apiresult;
let controller;
let action;
let url;

export default {

    
    /** 获取全部一级分类信息 **/
    GET_MEMBER_LIST(data) {
        controller='EsMember';
        action='GetList';
        url='/'+controller+'/'+action;
        return api({ url: url, method: "post", data: data }); 
    },

    /** 获取关注的会员 **/
    GET_MEMBER_ATTENTION(data) {
        controller='EsMember';
        action='GetMemberAttention';
        url='/'+controller+'/'+action;
        return api({ url: url, method: "post", data: data }); 
    },

    /** 获取会员信息类型 **/
    GET_MEMBER_TYPES(data) {
        controller='EsMember';
        action='GetTypeList';
        url='/'+controller+'/'+action;
        return api({ url: url, method: "post", data: data }); 
    },

    /** 获取会员信息 **/
    GET_MEMBER_FROZEN_LOG(data) {
        controller='EsMember';
        action='GetMemberFrozenLog';
        url='/'+controller+'/'+action;
        return api({ url: url, method: "post", data: data }); 
    },

    /** 获取冻结时间类型 **/
    GET_FROZEN_TIME(data) {
        controller='EsMember';
        action='GetFrozenTime';
        url='/'+controller+'/'+action;
        return api({ url: url, method: "post", data: data }); 
    },

    /** 冻结会员信息 **/
    SAVE_FROZEN(data) {
        controller='EsMember';
        action='MemberFrozen';
        url='/'+controller+'/'+action;
        return api({ url: url, method: "post", data: data }); 
    },

    /** 取消冻结会员信息 **/
    SAVE_UNFROZEN(data) {
        controller='EsMember';
        action='MemberUnFrozen';
        url='/'+controller+'/'+action;
        return api({ url: url, method: "post", data: data }); 
    },

    /** 获取会员信息详情 **/
    GET_MEMBER_INFO(data) {
        controller='EsMember';
        action='GetMemberInfo';
        url='/'+controller+'/'+action;
        return api({ url: url, method: "post", data: data }); 
    },

    /** 获取会员系统类型 **/
    GET_MEMBER_SYS_TYPE(data) {
        controller='EsMember';
        action='GetMemberSysType';
        url='/'+controller+'/'+action;
        return api({ url: url, method: "post", data: data }); 
    },

    /** 获取会员系统类型 **/
    ADD_MEMBER(data) {
        controller='EsMember';
        action='AddMember';
        url='/'+controller+'/'+action;
        return api({ url: url, method: "post", data: data }); 
    },

    /** 获取会员系统类型 **/
    EDIT_MEMBER(data) {
        controller='EsMember';
        action='EditMember';
        url='/'+controller+'/'+action;
        return api({ url: url, method: "post", data: data }); 
    },

    /** 获取认证费用设置列表 **/
    GET_AUTH_SETTING_LIST(data) {
        controller='EsMemberAuto';
        action='getList';
        url='/'+controller+'/'+action;
        apiresult=method.CheckMenuIsAuth(data,controller,action);
        if(apiresult.error > 0) return apiresult.result;
        return api({ url: url, method: "post", data: data });
    },

    /** 上下架会员认证费用设置 **/
    CHANGE_AUTO_PRICE_SHOW(data) {
        controller='EsMemberAuto';
        action='changeShow';
        url='/'+controller+'/'+action;
        apiresult=method.CheckMenuIsAuth(data,controller,action);
        if(apiresult.error > 0) return apiresult.result;
        return api({ url: url, method: "post", data: data });
    },

    /** 修改会员认证续费设置排序 **/
    CHANGE_AUTO_PRICE_SORT(data) {
        controller='EsMemberAuto';
        action='changeSort';
        url='/'+controller+'/'+action;
        apiresult=method.CheckMenuIsAuth(data,controller,action);
        if(apiresult.error > 0) return apiresult.result;
        return api({ url: url, method: "post", data: data });
    },

    /** 删除会员认证续费设置 **/
    DEL_AUTO_PRICE(data) {
        controller='EsMemberAuto';
        action='deleteAuto';
        url='/'+controller+'/'+action;
        apiresult=method.CheckMenuIsAuth(data,controller,action);
        if(apiresult.error > 0) return apiresult.result;
        return api({ url: url, method: "post", data: data });
    },

    /** 新增会员认证设置 **/
    ADD_AUTO_PRICE(data) {
        controller='EsMemberAuto';
        action='addAuto';
        url='/'+controller+'/'+action;
        apiresult=method.CheckMenuIsAuth(data,controller,action);
        if(apiresult.error > 0) return apiresult.result;
        return api({ url: url, method: "post", data: data });
    },

    /** 获取会员续费设置 **/
    GET_AUTO_PRICE_INFO(data) {
        controller='EsMemberAuto';
        action='GetAutoInfo';
        url='/'+controller+'/'+action;
        apiresult=method.CheckMenuIsAuth(data,controller,action);
        if(apiresult.error > 0) return apiresult.result;
        return api({ url: url, method: "post", data: data });
    },

    /** 保存会员认证费用设置 **/
    SAVE_AUTO_PRICE(data) {
        controller='EsMemberAuto';
        action='saveAutoPrice';
        url='/'+controller+'/'+action;
        apiresult=method.CheckMenuIsAuth(data,controller,action);
        if(apiresult.error > 0) return apiresult.result;
        return api({ url: url, method: "post", data: data });
    },

    /** 获取认证类型信息 **/
    GET_AUTH_TYPE(data) {
        controller='EsMember';
        action='GetMemberAuthType';
        url='/'+controller+'/'+action;
        apiresult=method.CheckMenuIsAuth(data,controller,action);
        if(apiresult.error > 0) return apiresult.result;
        return api({ url: url, method: "post", data: data });
    },

    /** 获取认证记录详情 **/
    GET_AUTH_LOG(data) {
        controller='EsMemberAuto';
        action='GetAuthLog';
        url='/'+controller+'/'+action;
        apiresult=method.CheckMenuIsAuth(data,controller,action);
        if(apiresult.error > 0) return apiresult.result;
        return api({ url: url, method: "post", data: data });
    },

    /** 获取认证审核状态 **/
    GET_AUTH_LOG_STATUS(data) {
        controller='EsMemberAuto';
        action='GetVerifyStatus';
        url='/'+controller+'/'+action;
        apiresult=method.CheckMenuIsAuth(data,controller,action);
        if(apiresult.error > 0) return apiresult.result;
        return api({ url: url, method: "post", data: data });
    },

    /** 认证状态审核 **/
    AUTH_VERIFY(data) {
        controller='EsMemberAuto';
        action='MemberVerify';
        url='/'+controller+'/'+action;
        apiresult=method.CheckMenuIsAuth(data,controller,action);
        if(apiresult.error > 0) return apiresult.result;
        return api({ url: url, method: "post", data: data });
    },

    /** 获取会员认证信息 **/
    GET_AUTH_INFO(data) {
        controller='EsMember';
        action='GetMemberAuthInfo';
        url='/'+controller+'/'+action;
        apiresult=method.CheckMenuIsAuth(data,controller,action);
        if(apiresult.error > 0) return apiresult.result;
        return api({ url: url, method: "post", data: data });
    },

    /** 修改会员认证信息 **/
    SAVE_MEMBER_AUTH_INFO(data) {
        controller='EsMember';
        action='SaveMemberAuthInfo';
        url='/'+controller+'/'+action;
        apiresult=method.CheckMenuIsAuth(data,controller,action);
        if(apiresult.error > 0) return apiresult.result;
        return api({ url: url, method: "post", data: data });
    },

    /** 修改会员vip时间 **/
    EDIT_MEMBER_VIP(data) {
        controller='EsMember';
        action='EditMemberVipTime';
        url='/'+controller+'/'+action;
        apiresult=method.CheckMenuIsAuth(data,controller,action);
        if(apiresult.error > 0) return apiresult.result;
        return api({ url: url, method: "post", data: data });
    },

    /** 获取会员余额信息列表 **/
    GET_MEMBER_BALANCE_LIST(data) {
        controller='EsMember';
        action='GetMemberMoneyLog';
        url='/'+controller+'/'+action;
        apiresult=method.CheckMenuIsAuth(data,controller,action);
        if(apiresult.error > 0) return apiresult.result;
        return api({ url: url, method: "post", data: data });
    },
   
}